import(/* webpackMode: "eager", webpackExports: ["CroquisCarousel"] */ "/home/u269702617/domains/symbiosis-paysage.fr/hbuilds/source/repository/components/croquis-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/u269702617/domains/symbiosis-paysage.fr/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/u269702617/domains/symbiosis-paysage.fr/hbuilds/source/repository/node_modules/next/dist/client/image-component.js");
